import { render, staticRenderFns } from "./demoBalance.vue?vue&type=template&id=58bf65dc"
import script from "./demoBalance.vue?vue&type=script&lang=js"
export * from "./demoBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports